import React, { useMemo, useEffect, useState, useRef } from 'react'
import { Box, Grid, InputLabel } from '@material-ui/core'
import { AddressField, AutoCompleteField, TextField } from '~/components/fields'
import { StyledSection, StyledSectionTitle, StyledSectionContent } from '../resume-parse-dialog.style'
import { OptionalLabel } from './optional-label'
import { countriesSelectOptionStore } from '~/stores/master-data/select-optionts.store'
import { observer } from 'mobx-react-lite'
import { TextareaField } from '@opus/web.core.form.textarea-field'
import { useTranslation } from '@opus/web.core.hooks.use-translation'
import { StateSearchStore } from '~/stores'
import { useFormikContext } from 'formik'
import { parseAddressToView } from '~/common/helpers'
const CandidateSection = observer(() => {
	const { t } = useTranslation()
	const { values, setFieldValue } = useFormikContext()
	const [selectedCountry, setSelectedCountry] = useState(values.candidate.country || 'US')
	const isFirstMount = useRef(true)

	const countryCode = useMemo(() => (selectedCountry || 'US').toUpperCase(), [selectedCountry])
	const componentRestrictions = useMemo(() => ({ country: [countryCode] }), [countryCode])

	const stateSearchStore = useMemo(() => new StateSearchStore(), [])
	useEffect(() => {
		stateSearchStore.setCountry(countryCode)
	}, [stateSearchStore, countryCode])

	useEffect(() => {
		if (values.candidate.address1) {
			setFieldValue('candidate.city', values.candidate.address1.city)
			setFieldValue('candidate.state', values.candidate.address1.stateShort)
			setFieldValue('candidate.zipcode', values.candidate.address1.zipcode)
		}
	}, [values.candidate.address1, setFieldValue])

	useEffect(() => {
		if (isFirstMount.current) {
			isFirstMount.current = false
			return
		}

		if (selectedCountry) {
			setFieldValue('candidate.address1', null)
			setFieldValue('candidate.city', '')
			setFieldValue('candidate.state', '')
			setFieldValue('candidate.zipcode', '')
		}
	}, [selectedCountry, setFieldValue])

	return (
		<StyledSection>
			<StyledSectionTitle>Candidate</StyledSectionTitle>
			<StyledSectionContent>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<Box display="flex" justifyContent="space-between" alignItems="center">
							<InputLabel shrink htmlFor="candidate.resume">
								{t('RESUME')}
							</InputLabel>
							<OptionalLabel />
						</Box>
						<TextareaField
							inputProps={{
								style: {
									backgroundColor: 'white',
									borderBottom: '1px solid #ccc',
									maxHeight: '200px',
									overflow: 'auto',
									padding: 0,
								},
							}}
							label=""
							name="candidate.resume"
							mode={'edit'}
							placeholder="Enter resume"
						/>
					</Grid>

					<Grid item xs={12}>
						<AutoCompleteField
							name="candidate.country"
							label="COUNTRY"
							placeholder="Enter country"
							options={countriesSelectOptionStore.dataSource}
							handleWithCurrentValue={(value) => {
								setSelectedCountry(value)
							}}
						/>
					</Grid>
					<Grid item xs={12}>
						<AddressField
							name="candidate.address1"
							label="ADDRESS"
							valueDisplayFormat={(data) => (data?.formatted_address ? parseAddressToView(data, ['street', 'city', 'state', 'zipcode', 'country']) : '')}
							componentRestrictions={componentRestrictions}
							validate={{}}
							errorField="formatted_address"
						/>
					</Grid>
					<Grid item xs={12}>
						<TextField name="candidate.suiteAptFloor" label="SUITE_APT_FLOOR" placeholder="Enter suite/apt/floor" endLabel={<OptionalLabel />} />
					</Grid>
					<Grid item xs={12}>
						<TextField name="candidate.city" label="CITY" placeholder="Enter city" endLabel={<OptionalLabel />} />
					</Grid>

					<Grid item xs={12}>
						<AutoCompleteField
							name="candidate.state"
							label="STATE"
							placeholder="Enter state"
							options={stateSearchStore.dataSource}
							endLabel={<OptionalLabel />}
						/>
					</Grid>
					<Grid item xs={12}>
						<TextField name="candidate.zipcode" label="ZIP" placeholder="Enter zip code" endLabel={<OptionalLabel />} />
					</Grid>
				</Grid>
			</StyledSectionContent>
		</StyledSection>
	)
})

export default CandidateSection
